export default (request, label) => {
    if (label) {
        request.headers.set('label', label);
    }

    return request;
};
